if (!customElements.get('vyv-shop-hero')) customElements.define('vyv-shop-hero', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.controller = new AbortController();
  const signal = this.controller.signal;
  const choices = [...this.querySelectorAll('[data-flavor-choice]')];
  const photos = [...this.querySelectorAll('[data-hero-photo]')];
  const dots = [...this.querySelectorAll('[data-hero-dot]')];
  const shop = this.querySelector('[data-hero-shop]');
  const status = this.querySelector('[data-hero-status]');
  const media = this.querySelector('.vyv-shop-hero__media');
  const autoplay = this.querySelector('[data-hero-autoplay]');
  if (!choices.length || choices.length !== photos.length) return;

  let current = 0;
  let inView = false;
  let focused = false;
  let pausedByUser = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const syncAutoplay = () => {
   window.clearInterval(this.autoplayTimer);
   if (inView && !focused && !pausedByUser && !document.hidden && choices.length > 1) {
    this.autoplayTimer = window.setInterval(() => show(current + 1, false), 3500);
   }
  };
  const show = (index, announce = true) => {
   current = (index + choices.length) % choices.length;
   const choice = choices[current];
   const name = choice.dataset.name;
   const key = choice.dataset.flavorChoice;
   const photo = photos[current];
   photo.loading = 'eager';
   photos[(current + 1) % photos.length].loading = 'eager';
   this.dataset.flavor = key;
   photos.forEach((item, i) => {
    item.classList.toggle('is-active', i === current);
    item.setAttribute('aria-hidden', i === current ? 'false' : 'true');
   });
   choices.forEach((item, i) => item.classList.toggle('is-active', i === current));
   dots.forEach((item, i) => {
    item.classList.toggle('is-active', i === current);
    item.setAttribute('aria-pressed', i === current ? 'true' : 'false');
   });
   this.querySelector('[data-photo-caption]').textContent = key === 'variety' ? 'All three flavors' : `Sparkling ${name}`;
   shop.href = choice.href;
   shop.querySelector('span').textContent = `Shop ${name}`;
   shop.setAttribute('aria-label', `Shop ${name}, 12 cans`);
   if (announce) status.textContent = `${name}. 12 cans.`;
  };

  const navigate = (index) => { show(index); syncAutoplay(); };
  this.querySelector('[data-hero-prev]')?.addEventListener('click', () => navigate(current - 1), { signal });
  this.querySelector('[data-hero-next]')?.addEventListener('click', () => navigate(current + 1), { signal });
  dots.forEach((dot, index) => dot.addEventListener('click', () => navigate(index), { signal }));
  const updateAutoplayButton = () => {
   autoplay.setAttribute('aria-label', pausedByUser ? 'Play slideshow' : 'Pause slideshow');
   autoplay.querySelector('span').textContent = pausedByUser ? '▶' : '❚❚';
  };
  updateAutoplayButton();
  autoplay.addEventListener('click', () => { pausedByUser = !pausedByUser; updateAutoplayButton(); syncAutoplay(); }, { signal });
  this.addEventListener('focusin', (event) => { focused = event.target.matches(':focus-visible'); syncAutoplay(); }, { signal });
  this.addEventListener('focusout', (event) => {
   if (event.relatedTarget && this.contains(event.relatedTarget)) return;
   focused = false;
   syncAutoplay();
  }, { signal });
  document.addEventListener('visibilitychange', syncAutoplay, { signal });
  this.observer = new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; syncAutoplay(); }, { threshold: 0.3 });
  this.observer.observe(media);

  let touchStartX = null;
  media.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true, signal });
  media.addEventListener('touchend', (event) => {
   if (touchStartX === null) return;
   const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
   touchStartX = null;
   if (Math.abs(distance) > 50) navigate(current + (distance < 0 ? 1 : -1));
  }, { passive: true, signal });
 }
 disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); window.clearInterval(this.autoplayTimer); this.ready = false; }
});
